import { JSX } from 'react';
import { SkeletonPulse } from '@bg-components/Skeleton';
import classes from './HowToPlay.module.scss';

interface IProps {
    showHeader?: boolean;
}

export const HowToPlaySkeleton = ({ showHeader = true }: IProps): JSX.Element => (
    <section className={classes.howToPlay}>
        {showHeader && (
            <header className={classes.header}>
                <h1>
                    <SkeletonPulse height="30px" width="150px" radius="15px" />
                </h1>
                <SkeletonPulse height="30px" width="100%" radius="5px" />
                <br />
                <SkeletonPulse height="30px" width="200px" radius="15px" />
            </header>
        )}
        <br />
        <SkeletonPulse height="400px" width="100%" />
        <br />
        <SkeletonPulse height="30px" width="250px" radius="15px" />
        <br />
        <SkeletonPulse height="55px" width="90%" radius="15px" />
        <br />
        <SkeletonPulse height="30px" width="200px" radius="15px" />
        <br />
        <SkeletonPulse height="75px" width="95%" radius="15px" />
        <br />
        <SkeletonPulse height="30px" width="230px" radius="15px" />
        <br />
        <SkeletonPulse height="65px" width="93%" radius="15px" />
    </section>
);
